import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
			>
				<rect
					x="4"
					y="3"
					width="16"
					height="18"
					rx="1.5"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.5"
				/>
				<path
					d="M9 10l2.5-2 2.5 2 3-3"
					stroke="currentColor"
					strokeWidth="1"
					fill="none"
					opacity=".5"
				/>
				<circle cx="9" cy="8" r="1.5" opacity=".4" />
			</svg>
		),
	},
} );
